import { styled } from '@mui/material/styles';
import { ErrorOutline } from '@mui/icons-material';

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
}));

const ErrorHeaders = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '2rem',
}));

const ErrorIcon = styled(ErrorOutline)(({ theme }) => ({
  width: '2rem',
  height: '2rem',
  color: theme.palette.error.main,
}));

const ErrorMessage = styled('p')({
  textAlign: 'center',
  fontSize: '1.8rem',
});

const ErrorPage = () => (
  <Root>
    <div>
      <ErrorHeaders>
        <ErrorIcon />
        <h1>Oops, algo deu errado!</h1>
      </ErrorHeaders>
      <ErrorMessage>
        Parece que houve um erro enquanto carregávamos essa página. Por favor,
        tente novamente mais tarde.
      </ErrorMessage>
    </div>
  </Root>
);

export default ErrorPage;
